<template lang="pug">
  v-dialog(v-model='dialog', max-width="600px" persistent)
    template(v-slot:activator='{ on }')
      v-list-tile(v-on='on')
        v-list-tile-title {{ $t('buttons.tryToAppeal') }}
    v-card
      v-toolbar(height="45" color='yellow')
        v-btn(icon, @click='close()')
          v-icon close
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.tryToAppeal') }}
      v-card-text
        v-container(grid-list-md)
          v-layout(align-center justify-space-around row fill-height wrap)
            v-flex
              div.pt-2.caption.grey--text {{ $t('labels.invoiceDate') }}
              div.subheading.font-weight-regular {{ appealValue.invoiceDate | moment("MM/DD/YYYY") }}
            v-flex
              div.pt-2.caption.grey--text {{ $t('labels.phoneNumber') }}
              div.subheading.font-weight-regular {{ appealValue.phoneNumber }}
            v-flex
              div.pt-2.caption.grey--text {{ $t('labels.saleType') }}
              div.subheading.font-weight-regular {{ appealValue.saleTypeDetail.selector }}
            v-flex(xs12)
              div.pt-2.caption.grey--text {{ $t('labels.phoneName') }}
              div.subheading.font-weight-regular {{ appealValue.phoneName }}
            v-flex
              div.pt-2.caption.grey--text {{ $t('labels.imeiNumber') }}
              div.subheading.font-weight-regular {{ appealValue.IMEINumber }}
            v-flex(v-if="appealValue.additionalIMEINumber")
              div.pt-2.caption.grey--text {{ $t('labels.additionalIMEINumber') }}
              div.subheading.font-weight-regular {{ appealValue.additionalIMEINumber }}
            v-flex
              div.pt-2.caption.grey--text {{ $t('labels.appealFor') }}
              div.subheading.font-weight-regular {{ appealValue.appealFor }}
            v-flex
              div.pt-2.caption.grey--text {{ $t('labels.amount') }}
              div.subheading.font-weight-regular {{ appealValue.amount | currency }}
          v-divider
          v-layout.pt-2(row wrap)
            v-flex(xs12 sm6)
              DateTimePicker(:showIcon="false"
                :range="false"
                :clearable="false"
                :hideTime="true"
                label="Appeal Date"
                v-on:input="setDueDate" 
                :initStartDate="$moment(new Date())" 
                :noFuture="true")
            v-flex(xs12 sm6)
              v-text-field(v-model="appeal.appealID" :error-messages="appealIDErrors" label='Appeal ID')  
            v-flex(xs12)
              v-radio-group(v-model='appeal.statusID', row)
                v-radio(label='Accepted', value='183')
                v-radio(label='Error', value='184')
            v-flex(xs12)    
              v-textarea(v-model="appeal.note" label="Note")  

                
      v-card-actions
        v-spacer
        v-btn(color='info', flat, @click='close()') Close
        v-btn(color='info' dark @click='update()') Save
      
</template>

<script>
import { mapGetters } from "vuex";
import AppealService from "../service.js";
import DateTimePicker from "../../../Global/components/DateTimePicker";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    appealValue: {
      default: null
    },
  },
  name: "create-reconcile",
  data() {
    return {
      dialog: false,
      appealFor: null,
      appeal: {
        statusID: '183',
        appealDate: new Date(),
        note: null,
        appealID: null,
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    appeal: {
      appealID: {
        required
      }
    }
  },
  computed: {
    appealIDErrors() {
      const errors = [];
      if (!this.$v.appeal.appealID.$dirty) return errors;
      if (!this.$v.appeal.appealID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  components: {
    DateTimePicker
  },
  watch: {
    dialog(val) {
      if (val) {
        this.appealFor = this.appealValue.appealFor
        this.id = this.appealValue.id
      }
    }
  },
  methods: {
    empty() {
      this.appealFor = null
      this.id = null
      this.appeal = {
        appealDate: new Date(),
        appealID: null,
        note: null,
      }
    },
    setDueDate(val) {
      this.appeal.appealDate = val;
    },
    close() {
      this.empty()
      this.dialog = false
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        AppealService.update(this.id, this.appeal)
        .then(result => {
          this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: "success",
            title: "Appeal was saved!"
          });
          this.close()
          this.$emit("created");
        });
      }
    }
  }
}
</script>
<style scoped>
  .v-dialog__container {
    display: none !important;
  }
</style>
